// 帮助中心详情
<template>
  <div class="helpDetail">
    <van-nav-bar left-arrow title="Help" @click-left="$router.go(-1)" left-arrow fixed placeholder />
    <section>
      <!-- <div class="title">
        {{ detail.problem || '' }}
      </div> -->
      <div v-html="detail.answer"></div>
    </section>
  </div>
</template>

<script>
import { getHelpDetail } from '@/api'
export default {
  name: 'HelpDetail',
  data () {
    return {
      detail: {}
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化列表
    async init () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true
      })
      await getHelpDetail(this.$route.query.id).then(res => {
        this.loading = false
        this.detail = res.data
      }).finally(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less">
  .helpDetail {
    padding: 30px;
    .my-swipe {
      margin-bottom: 25px;
      .van-swipe-item {
        overflow: hidden;
        border-radius: 10px;
        img {
          width: 100%;
        }
      }
    }
    .card {
      width: 100%;
      box-sizing: border-box;
      border-radius: 10px;
      margin-bottom: 20px;
      .card-item {
        height: 100%;
        .left {
          margin-right: 24px;
          .image {
            border: 5px solid #000000;
            border-radius: 50%;
            padding: 24px;
          }
          .point {
            position: relative;
            &:after {
              content: '';
              position: absolute;
              right: 18px;
              top: 20px;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background: #E8252A;
            }
          }
        }
        .right {
          border-bottom: 1px solid #828282;
          padding: 20px 0;
          width: 100%;
          .title {
            padding: 0;
            color: #000;
            font-size: 22px;
            font-weight: bold;
          }
          .content {
            padding: 20px 0;
            color: #000;
            font-size: 17px;
            line-height: 1.2;
            p {
              width: 80%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .date {
            font-size: 17px;
            color: #828282;
          }
        }
      }
    }
  }
</style>
